<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <!-- <div
              class="tabElement stock active"
              @click="changeTab('stock')"
            >
              <span class="material-icons-sharp"> app_registration </span>Manquant sur conteneur
            </div> -->
        <div
          class="tabElement simulation active"
          @click="changeTab('simulation')"
        >
          <span class="material-icons-sharp"> reduce_capacity </span>Simulation
          de bonus
        </div>
        <div class="tabElement historique" @click="changeTab('historique')">
          <span class="material-icons-sharp"> format_list_bulleted </span
          >Liste des demandes de bonus en attente
        </div>
        <div
          class="tabElement historiqueDone"
          @click="changeTab('historiqueDone')"
        >
          <span class="material-icons-sharp"> format_list_bulleted </span
          >Liste des demandes de bonus acceptées
        </div>
      </div>
</div>
      <div id="simulationTab" class="tabElementContent active">
        <div class="flexNoJustify">
          <div @click="makeSimulate" class="buttonAdd">
            <span> Simuler un scénario </span>
          </div>
        </div>
        <div class="flexNoJustify">
          <div class="fileForm">
            <div class="input-section">
              <label>Client</label>
              <input
                type="text"
                disabled
                class="disabled"
                v-model="buySimulateRecap.customer"
                placeholder="Client"
                required
              />
            </div>
            <div class="input-section">
              <label>Quantité Total vente</label>
              <input
                type="number"
                disabled
                class="disabled"
                v-model="buySimulateRecap.quantity"
                placeholder="Quantité Total vente"
                required
              />
            </div>
            <div class="input-section">
              <label>Montant Total vente</label>
              <input
                type="number"
                disabled
                class="disabled"
                v-model="buySimulateRecap.amount"
                placeholder="Montant Total vente"
                required
              />
            </div>
          </div>
        </div>

        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <img
              v-if="cardDetails.length == 0"
              src="../assets/empty2.png"
              alt=""
            />
            <tbody v-else>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in cardDetails"
                :key="item._id"
              >
                <td>
                  {{ item.cart ? item.cart.number : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.name : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.type : "" }}
                </td>
                <td>
                  {{ item.quantity }}
                </td>
                <td>
                  {{ item.amount }}
                </td>
                <td>
                  {{ item.store ? item.store.name : "" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="historiqueTab"
        :class="
          UserProfile.role == 'Administrateur'
            ? 'tabElementContent'
            : 'tabElementContent'
        "
      >
        <!-- <div @click="addNewReturnStock" class="buttonAdd">
              <span> Enregistrer une reprise de stock </span>
            </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th
                  v-for="item in UserProfile.role == 'Administrateur'
                    ? tableHeaderReduct
                    : tableHeaderReductUser"
                  :key="item"
                >
                  {{ item }}
                </th>
              </tr>
            </thead>
            <img
              v-if="reduction.length == 0"
              src="../assets/wallet.png"
              alt=""
            />
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in reduction"
                :key="item._id"
              >
                <td v-if="UserProfile.role == 'Administrateur'">
                  <div class="nameContentButton">
                    <div
                      @click="adminViewManipulateAskReduct(item)"
                      class="buttonAddSecond"
                    >
                      <span> Voir demande</span>
                    </div>
                  </div>
                </td>
                <td>
                  {{ item.status }}
                </td>
                <td>
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.name : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.type : "" }}
                </td>
                <td>
                  {{ item.amount }}
                </td>
                <td>
                  {{ item.startDate + " - " + item.endDate }}
                </td>
                <td>
                  {{ item.Observation ? item.Observation : " Néant" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div  id="historiqueDoneTab"
        :class="
          UserProfile.role == 'Administrateur'
            ? 'tabElementContent'
            : 'tabElementContent'
        "
      >
        <!-- <div @click="addNewReturnStock" class="buttonAdd">
              <span> Enregistrer une reprise de stock </span>
            </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th
                  v-for="item in UserProfile.role == 'Administrateur'
                    ? tableHeaderReduct
                    : tableHeaderReductUser"
                  :key="item"
                >
                  {{ item }}
                </th>
              </tr>
            </thead>
            <img
              v-if="reduction.length == 0"
              src="../assets/wallet.png"
              alt=""
            />
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in reduction"
                :key="item._id"
              >
                <td v-if="UserProfile.role == 'Administrateur'">
                  <div class="nameContentButton">
                    <div
                      @click="adminViewManipulateAskReduct(item)"
                      class="buttonAddSecond"
                    >
                      <span> Voir demande</span>
                    </div>
                  </div>
                </td>
                <td>
                  {{ item.status }}
                </td>
                <td>
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.name : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.type : "" }}
                </td>
                <td>
                  {{ item.amount }}
                </td>
                <td>
                  {{ item.startDate + " - " + item.endDate }}
                </td>
                <td>
                  {{ item.Observation ? item.Observation : " Néant" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
import { mapActions, mapGetters } from "vuex";
// import moment from "moment";
export default {
  name: "reductView",
  components: {},
  data: () => ({
    isSelecteds: [],
    isSelectedAll: false,
    tableHeader: [
      "Bon de commande",
      "Nom du Produit",
      "Produit type",
      "Quantité",
      "Montant",
      "Magasin",
    ],
    tableHeaderReduct: [
      "",
      "Statut",
      "Client",
      "Produit",
      "Type produit",
      "Montant bonus",
      "Période vérification",
      "Observation",
    ],
    tableHeaderReductUser: [
      "Statut",
      "Client",
      "Produit",
      "Type produit",
      "Montant bonus",
      "Période vérification",
      "Observation",
    ],
    buySimulateRecap: {
      quantity: 0,
      amount: 0,
      customer: "",
      product: "",
      startDate: "",
      endDate: "",
    },
  }),
  watch: {
    cardDetails() {
      if (!this.cardDetails || this.cardDetails.length === 0) return;
      this.buySimulateRecap = {
        quantity: 0,
        amount: 0,
        customer: "",
        product: "",
        startDate: "",
        endDate: "",
      };
      this.buySimulateRecap.customer = this.cardDetails[0].cart && this.cardDetails[0].cart.customer 
        ? this.cardDetails[0].cart.customer.name : "";
      const productNames = [];
      for (var i = 0; i < this.cardDetails.length; i++) {
        this.buySimulateRecap.quantity += Number(this.cardDetails[i].quantity);
        this.buySimulateRecap.amount += Number(this.cardDetails[i].amount);
        if (this.cardDetails[i].product && this.cardDetails[i].product.name) {
          productNames.push(this.cardDetails[i].product.name);
        }
      }
      this.buySimulateRecap.product = productNames.join(", ");
    },
  },
  computed: {
    ...mapGetters([
      //   "contratData",
      //   "blData",
      //   "conteneurData",
      "cardDetails",
      "reduction",
      "UserProfile",
      // "inventoryMissedData",
      //   "storeData",
    ]),
  },
  async mounted() {
    console.log("Vérification", this.UserProfile);
    // await this.getReductData({});
    await this.getUserProfile();
    if (this.UserProfile.role == "Administrateur") {
      // alert('ok')
      await this.getReductData({});
    }
    // await this.getCardDetails({
    //   startDate: "1960-01-01",
    //   endDate: "1960-01-01",
    // });
  },
  methods: {
    ...mapActions([
      //   "getContrat",
      //   "getSupplier",
      //   "getContratDetails",
      "getCustomerList",
      "getProduct",
      "getCardDetails",
      "getReductData",
      "getUserProfile",

      //   "getTransitaire",
      //   "getStore",
    ]),
    async adminViewManipulateAskReduct(item) {
      this.$emit("show", true);
      const value = {
        modalType: "adminViewManipulateAskReduct",
        status: item.status,
        _id: item._id,
        customer: item.customer ? item.customer.name : "",
        productName: item.product ? item.product.name : "",
        productType: item.product ? item.product.type : "",
        amount: item.amount,
        Observation: item.Observation ? item.Observation : " Néant",
        periodeSelect: item.startDate + " - " + item.endDate,
      };
      this.$emit("editeRowForDash", {
        name: "adminViewManipulateAskReduct",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async makeSimulate() {
      this.$emit("show", true);
      const value = {
        modalType: "makeSimulate",
      };
      await this.getProduct({});
      await this.getCustomerList({});
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "makeSimulate",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    raccourcirTexte(texte) {
      return texte;
    },
    async editeInventoryMissedDataRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.inventoryMissedData.length; i++) {
          this.inventoryMissedData[i].isSelected = false;
        }
        item.isSelected = true;
        const value = {
          _id: item._id,
          modalType: "editeInventoryMissedDataRow",
          observation: item.observation,
          quantity: item.quantity,
          store: item.store ? item.store.name : "",
          productId: item.product ? item.product._id : "",
          productName: item.product ? item.product.name : "",
        };
        console.log("--------------------------------", value);
        this.$emit("editeRowForDash", {
          name: "editeInventoryMissedDataRow",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);

      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeReturnStockRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.returnStockData.length; i++) {
          this.returnStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.returnStockData);
        await this.getProduct({});
        await this.getStore({});
        await this.getCustomerList({});
        const value = {
          _id: item._id,
          modalType: "editeReturnStockRowMagasin",
          product: item.product ? item.product.name : "",
          store: item.store ? item.store.name : "",
          customer: item.customer ? item.customer.name : "",
          quantity: item.quantity,
          amount: item.amount,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "editeReturnStockRowMagasin",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show", true);
      this.$emit("closeAllModal");
      if (tabName === "stock") {
        // await this.getConteneurAll({
        //   alreadyInStock: "Oui",
        //   haveAcknowledgeReceiptDate: "Oui",
        // });
      } else if (tabName === "historique") {
        await this.getReductData({ status: "Attente" });
      } else if (tabName === "historiqueDone") {
        await this.getReductData({ status: "Acceptée" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show", false);
    },
  },
};
</script>
      